module.exports = __webpack_public_path__ + "static/media/bootstrap.bbb99cea.jpg";